module.exports = __webpack_public_path__ + "0a4e212caaa2d0fefff25c230cc009fe.pdf";